import { render, staticRenderFns } from "./gestionCodigos.vue?vue&type=template&id=d1e24684"
import script from "./gestionCodigos.vue?vue&type=script&lang=js"
export * from "./gestionCodigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports